<template>
    <ErrorLayout>
        <span class="title">403</span>
        <span class="title second">{{ title }}</span>
        <span class="description">{{ description }}</span>
        <router-link
            to="/"
            exact
            class="button"
        >
            <div class="button-content">
                <img
                    src="@/assets/images/angle-icon.svg"
                    alt=""
                >
                <span class="button-title">{{ __('Go Back') }}</span>
            </div>
        </router-link>
    </ErrorLayout>
</template>

<script>
    import ErrorLayout from '@/components/pages/ErrorLayout'

    export default {
        components: { ErrorLayout },
        props: {
            payload: {
                default: () => ({}),
            },
        },
        computed: {
            title() {
                return this.__(this.payload?.title ?? 'forbidden')
            },
            description() {
                return this.__(this.payload?.description ?? 'Oops, something went wrong')
            },
        },
    }
</script>


